
import {RxDotFilled} from 'react-icons/rx'

export const FavArtistsList = [
    {
        id: 1,
        name: "Taylor Swift",
        imgSrc: '/img/profile.png',
        library: "196 songs in library",
        icon: <RxDotFilled className='m-2'/>
    },
    {
        id: 2,
        name: "Kanye West",
        imgSrc: '/img/profile.png',
        library: "124 songs in library",
        icon: <RxDotFilled className='m-2'/>
    },
    {
        id: 3,
        name: "Drake",
        imgSrc: '/img/profile.png',
        library: "50 songs in library",
        icon: <RxDotFilled className='m-2'/>
    },
    {
        id: 4,
        name: "Billie Eilish",
        imgSrc: '/img/profile.png',
        library: "15 songs in library",
        icon: <RxDotFilled className='m-2'/>
    },
    
]